export class BranchInfoData {
    constructor(branchInfo) {
        this.ID = branchInfo.ID;
        this.Name = branchInfo.Name;
        this.RankID = branchInfo.RankID;
        this.SortID = branchInfo.SortID;
        this.Code = branchInfo.Code;
        this.MasterEvents = branchInfo.MasterEvents;
        this.EventNames = branchInfo.EventNames;
        this.TotalLiveCount = branchInfo.TotalLiveCount;
        this.IsVirtualSport = branchInfo.IsVirtualSport;
        this.Visible = branchInfo.Visible;
        this.AllLiveVisible = branchInfo.AllLiveVisible;
        this.hasLiveEvents = branchInfo.hasLiveEvents;
    }
}
//# sourceMappingURL=BranchInfoData.js.map